import { render } from "./OverallStatistics.vue?vue&type=template&id=751c4d4a&scoped=true"
import script from "./OverallStatistics.vue?vue&type=script&lang=js"
export * from "./OverallStatistics.vue?vue&type=script&lang=js"

import "./OverallStatistics.vue?vue&type=style&index=0&id=751c4d4a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-751c4d4a"

export default script